<template>
  <div class="image-cloning">
    <!-- 顶部图片 -->
    <div class="header-image" @click="handleAddImage">
      <img src="https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250120/202501201720513ca8e4875.png"
        alt="Header Image" />
    </div>

    <!-- Tab部分 -->
    <el-tabs v-model="activeTab" class="tabs">
      <!-- 我的形象 -->
      <el-tab-pane label="我的形象" name="my-image">
        <div class="content">
          <!-- 复刻形象克隆的框 -->
          <el-card class="add-card" @click="handleAddImage">
            <div class="add-icon">
              <el-icon style="font-size: 50px;">
                <CirclePlusFilled />
              </el-icon>
            </div>
            <p style="font-weight: bold;font-size: 20px;">复刻形象克隆</p>
          </el-card>

          <!-- 我的形象卡片 -->
          <div class="work-card" v-for="(item, i) in myImages" :key="i">
            <!-- 封面区域 -->
            <div class="cover-area">
              <!-- 背景虚化层（仅竖版视频显示） -->
              <div v-if="item.isVertical" class="blur-bg"
                :style="{ backgroundImage: 'url(' + getVideoCover(item.videoUrl) + ')' }"></div>

              <!-- 中心封面 + 播放图标 -->
              <div class="cover-center" @click="openVideo(item)">
                <!-- 竖版视频：封面居中 -->
                <img v-if="item.isVertical && item.videoUrl" :src="getVideoCover(item.videoUrl)" class="center-cover"
                  alt="作品封面" />
                <!-- 横版视频：封面充满 -->
                <img v-else-if="item.videoUrl" :src="getVideoCover(item.videoUrl)" class="full-cover" alt="作品封面" />
                <div v-else class="cover-placeholder">无封面</div>
                <div class="play-icon">
                  <VideoPlay style="width: 36px; height: 36px; color: #fff;" />
                </div>
              </div>

              <!-- 模型标签 -->
              <div class="model-tag">
                适用模型：{{ item.model }}
              </div>

              <!-- 三个点，下拉里有命名、下载、删除 -->
              <el-dropdown trigger="click" class="more-dropdown">
                <span class="more-btn">
                  <More />
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item @click="openRenameDialog(item)">命名</el-dropdown-item>
                    <el-dropdown-item @click="onDownload(item)">下载</el-dropdown-item>
                    <el-dropdown-item @click="openDeleteDialog(item)">
                      <span style="color: red; font-weight: bold;">删除</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>

            <!-- 底部：标题 / 创建时间等信息 -->
            <div class="info-area" @click="openVideo(item)">
              <h4 class="work-title">{{ item.title }}</h4>
              <p class="create-time">创建时间: {{ item.createTime }}</p>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <!-- 公共形象 -->
      <el-tab-pane label="公共形象" name="public-image">
        <div class="content">
          <!-- 公共形象卡片 -->
          <div class="work-card" v-for="(item, i) in publicImages" :key="i">
            <!-- 封面区域 -->
            <div class="cover-area">
              <!-- 背景虚化层（仅竖版视频显示） -->
              <div v-if="item.isVertical" class="blur-bg"
                :style="{ backgroundImage: 'url(' + getVideoCover(item.videoUrl) + ')' }"></div>

              <!-- 中心封面 + 播放图标 -->
              <div class="cover-center" @click="openVideo(item)">
                <!-- 竖版视频：封面居中 -->
                <img v-if="item.isVertical && item.videoUrl" :src="getVideoCover(item.videoUrl)" class="center-cover"
                  alt="作品封面" />
                <!-- 横版视频：封面充满 -->
                <img v-else-if="item.videoUrl" :src="getVideoCover(item.videoUrl)" class="full-cover" alt="作品封面" />
                <div v-else class="cover-placeholder">无封面</div>
                <div class="play-icon">
                  <VideoPlay style="width: 36px; height: 36px; color: #fff;" />
                </div>
              </div>

              <!-- 模型标签 -->
              <div class="model-tag">
                适用模型：{{ item.model }}
              </div>
            </div>

            <!-- 底部：标题 / 创建时间等信息 -->
            <div class="info-area" @click="openVideo(item)">
              <h4 class="work-title">{{ item.title }}</h4>
              <p class="create-time">创建时间: {{ item.createTime }}</p>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 视频播放模态框 -->
    <el-dialog v-model="isVideoDialogVisible" :title="currentVideoTitle" width="50%" custom-class="video-dialog"
      :close-on-click-modal="false" @close="handleCloseDialog">
      <div class="dialog-content">
        <!-- 竖屏视频：保留背景虚化 -->
        <div v-if="isVertical" class="vertical-video-bg" :style="{ backgroundImage: 'url(' + currentVideoCover + ')' }">
        </div>

        <!-- 竖屏视频播放区域 -->
        <div v-if="isVertical" class="vertical-video-wrapper">
          <video class="vertical-video" :src="currentVideoUrl" autoplay controls />
        </div>

        <!-- 横屏视频：去掉背景虚化，直接充满模态框 -->
        <div v-else class="horizontal-video-wrapper">
          <video class="horizontal-video" :src="currentVideoUrl" autoplay controls />
        </div>
      </div>
    </el-dialog>

    <!-- 重命名弹窗 -->
    <el-dialog v-model="renameDialogVisible" title="重命名" width="30%">
      <el-input v-model="newTitle" placeholder="请输入新的标题" />
      <template #footer>
        <el-button @click="renameDialogVisible = false">取消</el-button>
        <el-button style="background-color: #ff5c00;border: none;" type="primary" @click="confirmRename">确认</el-button>
      </template>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog v-model="deleteDialogVisible" title="删除确认" width="30%">
      <p>确定要删除 <strong>{{ currentItem?.title }}</strong> 吗？</p>
      <template #footer>
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmDelete">确认删除</el-button>
      </template>
    </el-dialog>


    <!-- 右侧抽屉 -->
    <el-drawer v-model="drawerVisible" :title="drawerTitle" direction="rtl" size="22%">
      <div class="drawer-content">
        <!-- 第一步：上传视频要求 -->
        <div v-if="drawerStep === 1" class="step-1">
          <div class="upload-requirements">
            <h3>上传视频要求</h3>
            <ul>
              <li>只有一张人脸出境</li>
              <li>人脸不要太小，建议人脸宽度占整体画面宽度的1/3以上</li>
              <li>人脸不要太大，确保整张人脸都在屏幕区域内，人脸不要出屏幕</li>
              <li>确保面部特征没有被遮挡，并努力让面部清晰可见</li>
              <li>不要出现1、2、3手势动作</li>
            </ul>
          </div>

          <div class="poor-examples">
            <h4>拍摄不佳实例</h4>
            <div class="examples-grid">
              <div class="example">
                <img
                  src="https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250120/2025012017205151b355946.png"
                  alt="拍摄不佳实例" />
              </div>
            </div>
          </div>

          <!-- 下一步按钮 -->
          <div class="next-step">
            <el-button type="primary" @click="drawerStep = 2"
              style="background-color: #ff5c00;border: none;">下一步</el-button>
          </div>
        </div>

        <!-- 第二步：上传视频和创建数字人分身 -->
        <div v-else class="step-2">
          <h3>创建您的数字人分身</h3>
          <p class="subtitle">通过上传您的手机拍摄的视频(支持1080p、2K、4K)，1分钟轻松复刻您的专属数字人分身。</p>

          <!-- 上传视频区域 -->
          <div class="upload-section">
            <el-upload class="upload-video" :before-upload="beforeUpload" :on-success="handleSuccess"
              :on-error="handleError" :limit="1" :file-list="fileList">
              <div class="upload-box">
                <el-icon class="upload-icon">
                  <UploadFilled />
                </el-icon>
                <p class="upload-text">点击上传视频文件</p>
                <p class="upload-hint">支持 mp4 视频 最大 {{ videoDuration }}s，最小 5s，最大 {{ videoSize }}M</p>
              </div>
            </el-upload>
          </div>


          <!-- 数字人名称输入 -->
          <div class="name-input">
            <h3>名称</h3>
            <el-input v-model="digitalHumanName" placeholder="我的数字人名称" />
          </div>

          <!-- 免责声明 -->
          <div class="disclaimer">
            <h3>免责声明</h3>
            <ul>
              <li>请确认您使用的视频已获取其本人或团队授权。</li>
              <li>您承诺您上传的视频严格遵守中国的法律法规要求，不涉及黄、赌、毒，及任何形式的政治敏感信息等。</li>
              <li>如果您违反上述规定，存在任何违法行为，由此产生的所有法律责任由使用者自行承担。</li>
            </ul>
          </div>

          <!-- 取消和立即复刻按钮 -->
          <div class="action-buttons">
            <el-button @click="drawerStep = 1">取消复刻</el-button>
            <el-button type="primary" :loading="isLoading" @click="handleClone"
              style="background-color: #ff5c00;border: none;">立即复刻</el-button>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { CirclePlusFilled, VideoPlay, More, UploadFilled } from "@element-plus/icons-vue";

import { ElMessage } from "element-plus";
import axios from 'axios';
import { auth } from "@/utils/auth.js"; // 引入封装的 auth.js
import config from '@/config.js'; // 引入配置文件

export default {
  name: "ImageCloning",
  components: {
    CirclePlusFilled,
    VideoPlay,
    More,
    UploadFilled, // 注册上传图标

  },
  data() {
    return {
      activeTab: "my-image",
      myImages: [], // 我的形象数据
      publicImages: [], // 公共形象数据
      isVideoDialogVisible: false, // 控制模态框显示
      currentVideoUrl: "", // 当前播放的视频地址
      currentVideoTitle: "", // 当前播放的视频标题
      currentVideoCover: "", // 当前播放的视频封面
      isVertical: false, // 是否为竖屏视频
      renameDialogVisible: false, // 重命名弹窗显示
      deleteDialogVisible: false, // 删除弹窗显示
      newTitle: "", // 新标题
      currentItem: null, // 当前操作的项
      drawerVisible: false, // 控制抽屉显示
      drawerStep: 1, // 抽屉步骤，1 表示第一步，2 表示第二步
      fileList: [], // 上传的文件列表
      digitalHumanName: "", // 数字人名称
      videoDuration: 0, // 视频最大时长（秒）
      videoSize: 0, // 视频最大大小（MB）
      isLoading: false,  // 控制按钮 loading 状态

    };
  },
  created() {
    this.fetchImages(); // 页面加载时获取数据
    this.fetchVideoClarityValues(); // 获取视频时长和大小限制
  },

  computed: {
    // 动态设置抽屉标题
    drawerTitle() {
      return this.drawerStep === 1 ? "复刻第一步" : "复刻第二步";
    },
  },
  methods: {
    // 打开重命名弹窗
    openRenameDialog(item) {
      this.currentItem = item;
      this.newTitle = item.title; // 初始化输入框的值
      this.renameDialogVisible = true;
    },
    // 确认重命名
    async confirmRename() {
      if (this.newTitle && this.newTitle !== this.currentItem.title) {
        await this.renameImage(this.currentItem, this.newTitle);
      }
      this.renameDialogVisible = false;
    },
    // 打开删除弹窗
    openDeleteDialog(item) {
      this.currentItem = item;
      this.deleteDialogVisible = true;
    },
    // 确认删除
    async confirmDelete() {
      await this.deleteImage(this.currentItem);
      this.deleteDialogVisible = false;
    },
    async fetchImages() {
      const user = auth.getStoredUser();
      if (!user || !user.id) {
        ElMessage.error("用户未登录或用户ID无效");
        return;
      }

      try {
        const response = await axios.post(
          `${config.BASE_URL}/pc/api/video_sc_api.php`,
          {
            action: "get",
            user_id: user.id,
          }
        );

        if (response.data.success) {
          const allImages = await Promise.all(response.data.data.map(async (item) => {
            const videoElement = document.createElement('video');
            videoElement.src = item.video_url;
            await new Promise((resolve) => {
              videoElement.onloadedmetadata = () => {
                resolve();
              };
            });

            return {
              id: item.id,
              title: item.title,
              createTime: item.create_time,
              videoUrl: item.video_url,
              model: item.model,
              isOpen: item.is_open,
              isVertical: videoElement.videoHeight > videoElement.videoWidth, // 判断是否为竖版视频
            };
          }));

          // 根据 is_open 字段分类
          this.myImages = allImages.filter((item) => item.isOpen === 0); // 私模
          this.publicImages = allImages.filter((item) => item.isOpen === 1); // 公模
        } else {
          ElMessage.error(response.data.error || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        ElMessage.error("获取数据失败，请检查网络");
      }
    },
    // 获取视频时长和大小限制
    async fetchVideoClarityValues() {
      try {
        const response = await axios.get(`${config.BASE_URL}/pc/api/get_video_clarity_values.php`);
        if (response.data) {
          this.videoDuration = response.data.video_duration || 0; // 视频最大时长
          this.videoSize = response.data.video_size || 0; // 视频最大大小
        } else {
          ElMessage.error("获取视频限制失败");
        }
      } catch (error) {
        console.error("获取视频限制失败:", error);
        ElMessage.error("获取视频限制失败，请检查网络");
      }
    },
    // 生成视频封面图
    getVideoCover(videoUrl) {
      if (!videoUrl) return "";
      return `${videoUrl}?x-oss-process=video/snapshot,t_0,m_fast,ar_auto`;
    },

    // 打开视频播放
    openVideo(item) {
      this.currentVideoUrl = item.videoUrl; // 设置视频地址
      this.currentVideoCover = this.getVideoCover(item.videoUrl); // 生成封面图地址并赋值
      this.currentVideoTitle = item.title; // 设置视频标题
      this.isVertical = item.isVertical; // 设置是否为竖版视频
      this.isVideoDialogVisible = true; // 显示模态框
    },

    // 关闭模态框
    handleCloseDialog() {
      this.isVideoDialogVisible = false;
      this.currentVideoUrl = ""; // 清空视频地址
      this.currentVideoTitle = ""; // 清空视频标题
      this.currentVideoCover = ""; // 清空视频封面
      this.isVertical = false; // 重置竖屏状态
    },

    // 立即复刻按钮点击事件
    async handleClone() {
      if (!this.digitalHumanName) {
        ElMessage.error("请输入数字人名称");
        return;
      }
      if (this.fileList.length === 0) {
        ElMessage.error("请上传视频");
        return;
      }
      this.isLoading = true;
      const startTime = Date.now();
      try {
        const user = auth.getStoredUser();
        if (!user || !user.id) {
          ElMessage.error("用户未登录或用户ID无效");
          return;
        }

        // 调用后端接口保存视频信息
        const response = await axios.post(`${config.BASE_URL}/pc/api/video_sc_api.php`, {
          action: "add",
          user_id: user.id,
          title: this.digitalHumanName,
          video_url: this.fileList[0].url, // 假设上传成功后返回了视频 URL
          size_dx: this.fileList[0].size, // 文件大小
        });

        if (response.data.success) {
          ElMessage.success("复刻操作成功");
          this.drawerVisible = false; // 关闭抽屉
          this.fetchImages(); // 刷新数据
        } else {
          ElMessage.error(response.data.error || "复刻操作失败");
        }
      } catch (error) {
        console.error("复刻操作失败:", error);
        ElMessage.error("复刻操作失败，请检查网络");
      } finally {
        // 计算已消耗的时间
        const elapsed = Date.now() - startTime;
        const remainingTime = 3000 - elapsed;
        if (remainingTime > 0) {
          setTimeout(() => {
            this.isLoading = false;
          }, remainingTime);
        } else {
          this.isLoading = false;
        }
      }
    },

    // 下载视频（强制下载方案）
    onDownload(item) {
      if (!item.videoUrl) {
        ElMessage.error("视频地址无效，无法下载");
        return;
      }


      // 辅助方法：触发下载
      const triggerDownload = (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${item.title || 'video'}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // 释放内存
        ElMessage.success("视频下载中...");
      };

      // 方案1：使用Fetch API（推荐）
      const tryFetchDownload = () => {
        fetch(item.videoUrl)
          .then(response => {
            if (!response.ok) throw new Error('网络响应异常');
            return response.blob();
          })
          .then(blob => triggerDownload(blob))
          .catch(error => {
            console.error('Fetch下载失败:', error);
            tryXHRDownload(); // 降级到XHR方案
          });
      };

      // 方案2：使用XMLHttpRequest（备选）
      const tryXHRDownload = () => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', item.videoUrl, true);
        xhr.responseType = 'blob';

        xhr.onload = function () {
          if (this.status === 200) {
            triggerDownload(this.response);
          } else {
            fallbackToOpen();
          }
        };

        xhr.onerror = function () {
          fallbackToOpen();
        };

        xhr.send();
      };

      // 最终回退方案
      const fallbackToOpen = () => {
        ElMessage.warning('直接下载失败，尝试打开新窗口');
        window.open(item.videoUrl, '_blank');
      };

      // 执行下载尝试
      try {
        // 优先尝试Fetch方案
        if ('fetch' in window) {
          tryFetchDownload();
        } else {
          // 旧浏览器使用XHR方案
          tryXHRDownload();
        }
      } catch (error) {
        console.error('下载异常:', error);
        fallbackToOpen();
      }
    },

    // 重命名形象
    async renameImage(item, newTitle) {
      const user = auth.getStoredUser();
      if (!user || !user.id) {
        ElMessage.error("用户未登录或用户ID无效");
        return;
      }

      try {
        const response = await axios.post(
          `${config.BASE_URL}/pc/api/video_sc_api.php`,
          {
            action: "update",
            user_id: user.id,
            id: item.id, // 传递要修改的记录ID
            title: newTitle, // 新的标题
          }
        );

        if (response.data.success) {
          ElMessage.success("修改成功");
          this.fetchImages(); // 重新获取数据
        } else {
          ElMessage.error(response.data.error || "修改失败");
        }
      } catch (error) {
        console.error("修改失败:", error);
        ElMessage.error("修改失败，请检查网络");
      }
    },

    // 删除形象
    async deleteImage(item) {
      const user = auth.getStoredUser();
      if (!user || !user.id) {
        ElMessage.error("用户未登录或用户ID无效");
        return;
      }

      try {
        const response = await axios.post(
          `${config.BASE_URL}/pc/api/video_sc_api.php`,
          {
            action: "delete",
            user_id: user.id,
            id: item.id, // 传递要删除的记录ID
          }
        );

        if (response.data.success) {
          ElMessage.success("删除成功");
          this.fetchImages(); // 重新获取数据
        } else {
          ElMessage.error(response.data.error || "删除失败");
        }
      } catch (error) {
        console.error("删除失败:", error);
        ElMessage.error("删除失败，请检查网络");
      }
    },
    // 打开抽屉
    handleAddImage() {
      this.drawerVisible = true;
      this.drawerStep = 1; // 重置为第一步
      this.fileList = []; // 清空上传文件列表
      this.digitalHumanName = ""; // 清空数字人名称
    },

    // 上传前的校验
    async beforeUpload(file) {
      const isVideo = file.type === "video/mp4";
      const isLtMaxSize = file.size / 1024 / 1024 < this.videoSize; // 文件大小限制
      const isGtMinSize = file.size / 1024 / 1024 > 0.1; // 文件最小大小（0.1MB）

      // 校验文件类型
      if (!isVideo) {
        ElMessage.error("只能上传 MP4 格式的视频");
        return false;
      }

      // 校验文件大小
      if (!isLtMaxSize) {
        ElMessage.error(`视频大小不能超过 ${this.videoSize}MB`);
        return false;
      }
      if (!isGtMinSize) {
        ElMessage.error("视频大小不能小于 0.1MB");
        return false;
      }

      // 校验视频时长
      const duration = await this.getVideoDuration(file);
      if (duration < 5 || duration > this.videoDuration) {
        ElMessage.error(`视频时长必须在 5s 到 ${this.videoDuration}s 之间`);
        return false;
      }

      // 获取上传签名
      try {
        const signatureData = await this.getUploadSignature();
        if (!signatureData) {
          ElMessage.error("获取上传签名失败");
          return false;
        }

        // 使用签名上传文件到 OSS
        const uploadResult = await this.uploadToOSS(file, signatureData);
        if (uploadResult) {
          ElMessage.success("视频上传成功");
          return true;
        } else {
          ElMessage.error("视频上传失败");
          return false;
        }
      } catch (error) {
        console.error("上传失败:", error);
        ElMessage.error("视频上传失败，请重试");
        return false;
      }
    },

    // 获取视频时长
    getVideoDuration(file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = URL.createObjectURL(file);
        video.onloadedmetadata = () => {
          resolve(video.duration);
        };
        video.onerror = () => {
          reject(new Error("无法读取视频时长"));
        };
      });
    },

    // 获取上传签名
    async getUploadSignature() {
      try {
        const response = await axios.post(
          `${config.BASE_URL}/pc/api/upload_signature.php`,
          {
            type: 'video', // 上传类型为视频
          },
          {
            headers: {
              'Content-Type': 'application/json', // 设置请求头
            },
          }
        );

        // 检查接口返回的数据
        if (response.data && response.data.success) {
          // 确保返回的数据包含所有必需的字段
          const requiredFields = ['accessKeyId', 'policy', 'signature', 'bucket', 'endpoint', 'folder'];
          for (const field of requiredFields) {
            if (!response.data[field]) {
              throw new Error(`接口返回数据缺少字段: ${field}`);
            }
          }

          // 返回签名数据
          return response.data;
        } else {
          // 如果接口返回 success 为 false，抛出错误
          throw new Error(response.data.error || "获取上传签名失败");
        }
      } catch (error) {
        console.error("获取上传签名失败:", error);
        throw error;
      }
    },

    // 上传文件到 OSS
    async uploadToOSS(file, signatureData) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("key", `${signatureData.folder}${file.name}`); // 文件路径
        formData.append("policy", signatureData.policy); // 上传策略
        formData.append("OSSAccessKeyId", signatureData.accessKeyId); // AccessKeyId
        formData.append("signature", signatureData.signature); // 签名
        formData.append("success_action_status", "200"); // 上传成功时返回的状态码
        formData.append("file", file); // 文件

        axios.post(
          `https://${signatureData.bucket}.${signatureData.endpoint}`, // OSS 上传地址
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data", // 设置请求头
            },
          }
        )
          .then((response) => {
            if (response.status === 200) {
              // 上传成功
              const videoUrl = `https://${signatureData.bucket}.${signatureData.endpoint}/${signatureData.folder}${file.name}`;
              this.fileList = [{ name: file.name, url: videoUrl, size: file.size }]; // 更新文件列表
              resolve(true);
            } else {
              // 上传失败
              console.error("上传失败：", response);
              reject(new Error("上传失败"));
            }
          })
          .catch((error) => {
            console.error("上传失败：", error);
            reject(error);
          });
      });
    },


  },
};
</script>

<style scoped>
.image-cloning {
  background-color: #fff;
  padding: 0 20px;
}

.header-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  cursor: pointer;
}

.tabs {
  margin-top: 20px;
}

.content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.add-card {
  border: 2px dashed #ff5c00;
  background-color: #ffe6cc;
  border-radius: 8px;
  text-align: center;
  width: 310px;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.add-card:hover {
  background-color: #ffd8a6;
}

.add-icon {
  font-size: 32px;
  color: #ff5c00;
  margin-bottom: 10px;
}

/* 我的形象卡片样式 */
.work-card {
  width: 320px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  cursor: pointer;
}

.cover-area {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
  background-color: #eee;
}

.blur-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: blur(8px);
  transform: scale(1.2);
  opacity: 0.7;
  z-index: 1;
}

.cover-center {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.center-cover {
  width: 100px;
  height: auto;
  border-radius: 4px;
  object-fit: cover;
}

.full-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-placeholder {
  width: 100px;
  height: 100px;
  background-color: #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}

.play-icon {
  position: absolute;
  cursor: pointer;
}

.play-icon svg {
  width: 36px;
  height: 36px;
  color: #fff;
}

.play-icon:hover svg {
  color: #ff5c00;
}

.model-tag {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 12px;
  color: #333;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 4px 8px;
  border-radius: 4px;
  z-index: 3;
}

.more-dropdown {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 3;
}

.more-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.more-btn:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

.more-btn>svg {
  width: 20px;
  height: 20px;
}

.info-area {
  padding: 12px;
}

.work-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.create-time {
  margin: 4px 0 0;
  font-size: 12px;
  color: #999;
}

/* 自定义模态框样式 */
.video-dialog .el-dialog__header {
  background-color: #333;
  color: #fff;
  padding: 10px 20px;
}

.video-dialog .el-dialog__title {
  color: #fff;
}

.video-dialog .el-dialog__body {
  padding: 20px;
}

.video-dialog .el-dialog__footer {
  text-align: center;
  padding: 10px 20px;
}

/* 弹窗内容区 */
.dialog-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 400px;
  overflow: hidden;
}

/* 竖屏视频的背景 */
.vertical-video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: blur(8px);
  z-index: 1;
}

/* 竖屏视频播放区域 */
.vertical-video-wrapper {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.vertical-video {
  max-height: 100%;
  max-width: 80%;
  border-radius: 8px;
}

/* 横屏视频播放区域 */
.horizontal-video-wrapper {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.horizontal-video {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}

.drawer-content {
  margin-top: -30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 第一步样式 */
.step-1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-requirements h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.upload-requirements ul {
  list-style-type: disc;
  margin-left: 5px;
  color: #666;
  line-height: 1.6;
  font-size: 14px;
  background: #f7f8fa;
  padding-top: 10px;
  padding-bottom: 10px;
}

.poor-examples h4 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.examples-grid {
  display: flex;
  justify-content: center;
}

.example img {
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 8px;
}

.next-step {
  text-align: center;
}

/* 第二步样式 */
.step-2 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.step-2 h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.step-2 .subtitle {
  font-size: 14px;
  color: #666;
  margin-top: -20px;

}

/* 上传框样式 */
.upload-section {
  text-align: center;
}

.upload-video {
  border: 2px dashed #ff5c00;
  border-radius: 8px;
  background-color: #fff4e6;
  padding: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.upload-video:hover {
  background-color: #ffe6cc;
}

.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.upload-icon {
  font-size: 40px;
  color: #ff5c00;
}

.upload-text {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.upload-hint {
  font-size: 14px;
  color: #666;
}

/* 数字人名称输入 */
.name-input {
  margin-top: 20px;
}

/* 免责声明 */
.disclaimer {
  margin-top: 20px;

}

.disclaimer h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.disclaimer ul {
  list-style-type: disc;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #666;
  line-height: 1.6;
  font-size: 14px;
  background: #f7f8fa;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>